export const IDD_MIN_TRAINING_DURATION_MINUTES = 15;

export const IDD_MIN_ESCALATION_DURATION_HOURS = 1;
export const IDD_MAX_ESCALATION_DURATION_HOURS = 15;
